import React, { useState, useEffect } from 'react';
import { Check } from 'lucide-react';

const WELCOME_SHOWN_KEY = 'jobasti_welcome_shown';

const HERO_IMG = 'https://images.unsplash.com/photo-1565688335719-d0297c355556?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxqb2IlMjBjYW5kaWRhdGUlMjBzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwaGFuZHNoYWtlJTIwY2FyZWVyfGVufDB8fHx8MTc3NDYxMjAxN3ww&ixlib=rb-4.1.0&q=85';

const WelcomeModal = ({ onDismiss, orgName }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const shown = localStorage.getItem(WELCOME_SHOWN_KEY);
    if (shown) {
      onDismiss?.();
    } else {
      setVisible(true);
    }
  }, []);

  const handleContinue = () => {
    localStorage.setItem(WELCOME_SHOWN_KEY, JSON.stringify({ timestamp: Date.now() }));
    setVisible(false);
    onDismiss?.();
  };

  if (!visible) return null;

  const bullets = [
    'No cover letter needed',
    'One profile for thousands of jobs',
    'AI-powered match scoring',
  ];

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9998,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
      backdropFilter: 'blur(4px)',
    }} data-testid="welcome-modal-overlay">
      <div style={{
        background: '#fff', borderRadius: 16, width: '100%', maxWidth: 560,
        boxShadow: '0 24px 64px rgba(0,0,0,0.16), 0 0 0 1px rgba(0,0,0,0.04)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        overflow: 'hidden',
      }} data-testid="welcome-modal">

        {/* Top section: logo + image */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
          padding: '28px 32px 0',
        }}>
          <span style={{
            fontSize: 22, fontWeight: 800, color: '#2563eb', letterSpacing: '-0.5px',
            marginTop: 4,
          }}>
            Jobasti
          </span>
          <div style={{
            width: 120, height: 100, borderRadius: 14, overflow: 'hidden',
            background: '#dbeafe', flexShrink: 0,
          }}>
            <img
              src={HERO_IMG}
              alt="Career opportunity"
              style={{ width: '100%', height: '100%', objectFit: 'cover', mixBlendMode: 'multiply' }}
            />
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: '20px 32px 28px' }}>
          <h2 style={{
            fontSize: 28, fontWeight: 800, color: '#0f172a',
            margin: '0 0 8px 0', lineHeight: 1.2, letterSpacing: '-0.5px',
          }}>
            Land your dream job!
          </h2>
          <p style={{
            fontSize: 15, fontWeight: 500, color: '#475569',
            margin: '0 0 16px 0', lineHeight: 1.5,
          }}>
            Jobasti is the recruiting partner of {orgName || 'this company'}.
          </p>
          <p style={{
            fontSize: 14, color: '#64748b', lineHeight: 1.7,
            margin: '0 0 28px 0',
          }}>
            This means you simply apply through Jobasti. In the next step you fill in your details once, creating your Jobasti profile and applying for this job at the same time. Easy, because:
          </p>

          {/* Bullet points */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 32 }}>
            {bullets.map((text, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 32, height: 32, borderRadius: 8,
                  background: '#eff6ff', border: '1px solid #dbeafe',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <Check style={{ width: 16, height: 16, color: '#2563eb' }} />
                </div>
                <span style={{ fontSize: 15, fontWeight: 500, color: '#1e293b' }}>{text}</span>
              </div>
            ))}
          </div>

          <button
            onClick={handleContinue}
            data-testid="welcome-continue-btn"
            style={{
              width: '100%', padding: '14px 0', fontSize: 15, fontWeight: 600,
              background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10,
              cursor: 'pointer', transition: 'background 0.2s',
              boxShadow: '0 2px 8px rgba(37,99,235,0.25)',
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
